<script lang="ts">
    import type DataProvider from '../services/data.provider'
    import type TabsProvider from '../services/tabs.provider'
    import type ServiceProvider from '../services/service.provider'
    import Filter2 from './Filter2.svelte'

    export let dataProvider: DataProvider
    export let tabsProvider: TabsProvider
    export let serviceProvider: ServiceProvider
</script>

<Filter2
    {dataProvider}
    {tabsProvider}
    {serviceProvider}
/>
